import { getEnvErrors } from "../required-env-vars.js";

// ADR-0031: every variable is required, with no default in code. vite.config.js already refuses to
// build with a bad env; this re-check covers the dev server and tests, with the same single error.
const envErrors = getEnvErrors(import.meta.env);
if (envErrors.length > 0) {
	throw new Error(`Invalid environment configuration:\n- ${envErrors.join("\n- ")}`);
}

export const appEnvironment = import.meta.env.REACT_APP_APP_ENVIRONMENT;
export const appTitle = import.meta.env.REACT_APP_APP_TITLE;
export const apiBase = import.meta.env.REACT_APP_API_BASE;
export const wsApiBase = import.meta.env.REACT_APP_WS_API_BASE;
export const webBase = import.meta.env.REACT_APP_WEB_BASE;
export const supabaseUrl = import.meta.env.REACT_APP_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.REACT_APP_SUPABASE_ANON_KEY;
export const hasMobileApp = import.meta.env.REACT_APP_HAS_MOBILE_APP === "true";
// Optional: an empty value turns Sentry off. This maps "off" to undefined; it is not a default.
export const sentryDsn: string | undefined = import.meta.env.REACT_APP_SENTRY_DSN || undefined;

export const isDevelopment = import.meta.env.DEV === true;

// Derived classification of the configured API, not an env default.
const getApiUrlBasedEnvironment = () => {
	if (apiBase.includes("https://staging")) {
		return "staging";
	}

	if (apiBase.includes("https://api")) {
		return "production";
	}

	return "development";
};

export const apiUrlBasedEnvironment = getApiUrlBasedEnvironment();

export const isRunningAgainstProduction = (): boolean => apiBase.includes("https://api");

export const isRunningAgainstStaging = (): boolean => apiBase.includes("https://staging");

export const isDevelopmentWithProductionApi = (): boolean => {
	return isDevelopment && (isRunningAgainstProduction() || isRunningAgainstStaging());
};
